import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import { requireAuthContext } from '../../authorization/GlobalAuthContext'
import JobStatus = com.eidu.sharedlib.entity.job.JobStatus

type GetJobStatusParameters = {
  jobId: string
}

const getJobStatus = async ({ jobId }: GetJobStatusParameters): Promise<JobStatus> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/job-status/${jobId}`, {
    headers: {
      Authorization: `Bearer ${authContext.accessToken}`,
      Accept: 'application/json',
    },
  }).then(async (response): Promise<JobStatus> => {
    if (response.status !== 200) throw Error(`Unexpected response code ${response.status} from job status endpoint`)

    return JobStatus.fromJsonString(await response.text())
  })
}

export default getJobStatus
